import React from 'react'
import Button from '../Button/Button'
import ButtonIcon from '../ButtonIcon/ButtonIcon'

const FormFile = ({
  id,
  name = undefined,
  className = undefined,
  placeholder = undefined,
  disabled = undefined,
  value = undefined,
  onChange = undefined,
  checked = undefined,
  readOnly = undefined,
  filename = undefined,
  icon = undefined,
  iconPos = undefined,
  size = undefined,
  accept = undefined,
  variant = 'default',
  buttonProps = {},
  buttonIconProps = {},
  multiple = false,
}) => {
  return (
    <div
      className={
        'formfile' +
        (disabled ? ' formfile--disabled' : '') +
        (size ? ' formfile--' + size : ' formfile--md') +
        (className ? ' ' + className : '')
      }
    >
      <label className={`formfile__input-wrap`}>
        <input
          checked={checked}
          name={name}
          id={id}
          value={value}
          className="formfile__input"
          type="file"
          disabled={disabled}
          onChange={onChange}
          readOnly={readOnly}
          accept={accept}
          multiple={multiple}
        />
        <span className={`formfile__content ${variant === 'button' ? 'formfile__content--button' : ''}`}>
          {icon && iconPos === 'left' && <span className="formfile__icon">{icon}</span>}
          {filename ? (
            <span className="formfile__filename">{filename}</span>
          ) : (
            <>
              {variant === 'default' && <span className="formfile__label">{placeholder ? placeholder : ''}</span>}
              {variant === 'button' && <Button label={placeholder} icon={icon} icon_pos={'left'} variant={'primary'} className="formfile__button" {...buttonProps} />}
              {variant === 'buttonIcon' && <ButtonIcon variant={'primary'} className="formfile__button" {...buttonIconProps} />}
            </>
          )}
          {icon && variant === 'default' && iconPos !== 'left' && <span className="formfile__icon">{icon}</span>}
        </span>

      </label>
    </div>
  )
}

export default FormFile
